<template>
  <div class="real-container">
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-row"
      >
        <h2 class="content-tit">
            {{pageTitle}}
        </h2>
        <div class="data-control">
          <button type="button" class="search-btn button" @click="searchMstOrder()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
            검색
          </button>
          <button type="button" class="button data-excel" @click="exportExcel()" v-if="ownerKey !== 'A08462'">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
            엑셀다운
          </button>
          <button type="button" class="button search-btn print" @click="printStockList()" data-hidden="mobile" v-if="ownerKey !== 'A08462'">
            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 96 960 960" width="18" fill="#ffffff"><path d="M350 566q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T350 506h260q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T610 566H350Zm0-160q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T350 346h260q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T610 406H350ZM220 666h320q26.43 0 49.215 12Q612 690 628 710l112 146V236H220v430Zm0 250h490L581 747q-7.565-9.882-18.283-15.441Q552 726 540 726H220v190Zm520 60H220q-24 0-42-18t-18-42V236q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18Zm-520-60V236v680Zm0-190v-60 60Z"/></svg>
            발주서
          </button>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="occurrence-start">
          주문일자 
        </label>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateFromMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceFromMain"
                  prepend-icon="mdi-calendar"      
                  label="From"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceFromMain"
                locale="ko"
                @input="dateFromMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateToMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceToMain"
                  prepend-icon="mdi-calendar"      
                  label="To"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceToMain"
                locale="ko"
                @input="dateToMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col client-ui"
      >
      <label class="default-tit input-tit text-center" for="client-tit">
          거래처 
        </label>
        <div class="client-box">
          <input type="text"
            class="default-input client-input left"
            @click="clientFlag = true"
            id="client-tit"
            v-model="strCustCd"
            :disabled="custList.length <= 1"
          />
          <button type="button"
            @click="clientFlag = true"
            v-if="custList.length > 1"
            class="client-search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </button>
          <input type="text" class="default-input client-input right" id="client-right" v-model="strCustNm" disabled/>
        </div>
      </v-col>
      <!--<v-col
        cols="12"
        md="4"
        class="ui-col client-ui impose-ui"
      >
      <label class="default-tit input-tit text-center" for="impose-tit">
          부과
        </label>
        <div class="client-box">
          <input type="text"
            class="default-input client-input left"
            @click="imposeFlag = true"
            id="impose-tit"
            v-model="strDeptCd"
            :disabled="deptList.length <= 1"
          />
          <button type="button"
            @click="imposeFlag = true"
            v-if="deptList.length > 1"
            class="client-search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </button>
          <input type="text" class="default-input client-input right" id="impose-right" v-model="strDeptNm" disabled/>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="ui-col"
      >-->
      <!--<label class="default-tit input-tit text-center" for="select-name">
          주문구분
        </label>
        <multiselect
          id="select-name"
          v-model="locationVal"
          :options="locationOption"
          :multiple="false"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="주문구분을 구분을 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">주문구분을 구분을 선택해주세요.</span></multiselect>
      </v-col>-->
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="processing-status">
          주문현황
        </label>
        <multiselect
          id="processing-status"
          v-model="processingVal"
          :options="processingOption"
          :multiple="false"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="주문현황을 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">주문현황을 선택해주세요.</span></multiselect>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="processing-status">
          배송구분
        </label>
        <multiselect
          id="processing-status"
          v-model="deliveryVal"
          :options="deliveryOption"
          :multiple="false"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="배송구분을 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">배송구분을 선택해주세요.</span></multiselect>
      </v-col>
    </v-row>
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="8"
        class="ui-col d-flex flex-column"
      >
          <h3 class="grid-tit">{{cardMstTitle}}</h3>
          <!--<div id="master-left-data" class="real-grid"></div>-->
          <div id="master-grid" class="real-grid"></div>
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="ui-col d-flex flex-column"
      >
          <h3 class="grid-tit">{{cardDtlTitle}}</h3>
          <!--<div id="master-left-data" class="real-grid"></div>-->
          <div id="detail-grid" class="real-grid"></div>
      </v-col>
    </v-row>
    <div data-app>
    <v-dialog
      v-model="clientFlag"
      persistent
      max-width="800px"
      id="user-info-modal"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{clientPopTitle}}</span>
        </v-card-title>
        <v-card-text class="regist-container">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
                class="client-col regist-col"
              >
                <CustPopup ref="custPopRef" v-if="clientFlag" @selectCustEvent="selectCustPop"></CustPopup>
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="regist-col last justify-end"
              >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="custInit()"
                >
                  초기화
                </v-btn>
                <v-btn
                  class="default-btn-style"
                  color="blue darken-1"
                  text
                  @click="clientFlag = false"
                >
                  닫기
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <div data-app>
    <v-dialog
      v-model="imposeFlag"
      persistent
      max-width="500px"
      id="user-info-modal2"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{imposePopTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <ImposePopup ref="imposePopRef" v-if="imposeFlag" @selectImposeEvent="selectImposePop" v-bind:deptList="deptList"></ImposePopup>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-card-actions>
                  <v-spacer>
                  </v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deptInit()"
                  >
                    초기화
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="imposeFlag = false"
                  >
                    닫기
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <div report-app class="report-modal">
      <v-dialog
        v-model="printDialog"
        persistent
        id="report-modal"
        content-class="report-modal"
      >
        <v-card class="report-card">
          <v-card-title>
            <span class="text-h5">{{cardTitle}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <!--<div id="ozviewer" class="ozviewer">
                    <OZViewer></OZViewer>
                  </div>-->
                  <OZViewer ref="ozViewerRef" v-if="printDialog"></OZViewer>
                </v-col>
              </v-row>
            </v-container>
            <!--<small>*indicates required field</small>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer>
            </v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="printDialog = false"
            >
              닫기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import JSZip from 'jszip'
import router from '../router'
import CustPopup from '@/components/CustPopup.vue'
import ImposePopup from '@/components/ImposePopup.vue'
import { GridView, LocalDataProvider } from 'realgrid'
import { ordMstFields, ordMstColumns, ordDtlFields, ordDtlColumns } from './gridData/OrderSearche.js'
import { mapGetters } from 'vuex'
// import OZViewer from '../../components/OZViewer.vue'


let mstGridView = GridView
let mstDataProvider = LocalDataProvider

let dtlGridView = GridView
let dtlDataProvider = LocalDataProvider

export default {
  name: 'OrderSearch',
  components: {
    CustPopup,
    ImposePopup
  },  
  data() {
    return {
      // v-dialog API https://vuetifyjs.com/en/api/v-dialog/
      pageTitle:'주문조회',
      cardTitle: '거래처별배분 내역',
      cardMstTitle: '주문 상세내역',
      cardDtlTitle: '제품 상세 내역',
      clientFlag: false,
      imposeFlag: false,
      dateToMain: false,
      occurrenceToMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFromMain: false,
      occurrenceFromMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      locationOption: [],
      locationVal: '',
      processingOption: [
        {
          name: '전체',
          value: ''
        },
        {
          // 미처리
          name: '주문접수',
          value: 1
        },
        {
          // 접수
          name: '주문확인',
          value: 2
        },
        {
          // 확정 ( 실제 출구 완료가 아님)
          name: '출고완료',
          value: 3
        }
      ],
      processingVal: '',
      deliveryOption: [],
      deliveryVal: '',
      clientPopFlag: false,
      clientPopTitle: '거래처 선택',
      imposePopFlag: false,
      imposePopTitle: '부과 선택',
      custInsList: [],
      mstListData: [
      ],
      custList: [],
      strCustCd: '',
      strCustNm: '',
      deptList: [],
      strDeptCd: '',
      strDeptNm: '',
      ownerKey: '',
      userId: '',
      userName: '',
      agentCd: '',
      orderMstList: '',
      orderDtlList: '',
      printDialog: false
    }
  },
  created() {
    //console.log('------- cust ---------')
    var info = JSON.parse(sessionStorage.getItem('userInfo'))
    var selectOwner = sessionStorage.getItem('selectOwner')

    this.ownerKey = selectOwner
    // console.log(info[0])
    this.userId = info[0].userId
    this.userName = info[0].userNm
    // console.log(info)
    if(this.codeInfoObj === '' || this.codeInfoObj === null){
      setTimeout(() => {
        this.initSettings()
        this.$loadingHide()
      }, 1000)
    }else{
      this.initSettings()
    }
  },
  methods: {
    selectCustPop(popData){
      this.strCustCd = popData.custCd
      this.strCustNm = popData.custNm
      this.clientFlag = false

      this.deptList = []
      for(var i=0; i<this.custInfoObj.length; i++){
        var item = this.custInfoObj[i]

        if(item.custCd === this.strCustCd){
          this.deptList.push(item)
        }
      }
      
      if(this.deptList.length === 1){
        this.strDeptCd = this.deptList[0].deptCd
        this.strDeptNm = this.deptList[0].deptNm
      }

    },
    selectImposePop(popData){
      //console.log('selectImposePop ===========')
      //console.log(popData)
      this.strDeptCd = popData.deptCd
      this.strDeptNm = popData.deptNm
      this.imposeFlag = false  
    },
    custInit(){
      this.strCustCd = ''
      this.strCustNm = ''
      this.strDeptCd = ''
      this.strDeptNm = ''
      this.clientFlag = false
    },
    deptInit(){
      this.strDeptCd = ''
      this.strDeptNm = ''
      this.imposeFlag = false  
    },
    initSettings(){
      this.custList = []
      //console.log(this.custInfoObj)
      for(var i=0; i<this.custInfoObj.length; i++){
        var item = {'custCd' : this.custInfoObj[i].custCd, 'custNm' : this.custInfoObj[i].custNm }
        if(this.custList.findIndex((items) => items.custCd == this.custInfoObj[i].custCd) === -1){
          this.custList.push(item)
        }
      }

      if(this.custList.length === 1){
        this.strCustCd = this.custList[0].custCd
        this.strCustNm = this.custList[0].custNm

        this.deptList = []
        for(var idx=0; idx<this.custInfoObj.length; idx++){
          var deptItem = this.custInfoObj[idx]

          if(deptItem.custCd === this.strCustCd){
            this.deptList.push(deptItem)
          }
        }
        
        if(this.deptList.length === 1){
          this.strDeptCd = this.deptList[0].deptCd
          this.strDeptNm = this.deptList[0].deptNm
        }
      }
      
      this.deliveryOption = [
        {
          name: '전체',
          value: ''
        }
      ]
      for(var j=0; j<this.codeInfoObj.length; j++){
        if(this.codeInfoObj[j].mstCode === 'DELICD'){
          var divItem = {'name' : this.codeInfoObj[j].dtlCodeNm, 'value' : this.codeInfoObj[j].dtlCode}
          this.deliveryOption.push(divItem)
        }
      }

      this.locationOption = [
        {
          name: '전체',
          value: ''
        }
      ]
      for(var k=0; k<this.codeInfoObj.length; k++){
        if(this.codeInfoObj[k].mstCode === 'ORDCD'){
          var ordItem = {'name' : this.codeInfoObj[k].dtlCodeNm, 'value' : this.codeInfoObj[k].dtlCode}
          this.locationOption.push(ordItem)
        }
      }
      //console.log(this.codeInfoObj)
      //console.log(this.deliveryOption)

      // console.log(this.custList)
    },
    searchMstOrder() {
      this.$loading.show({delay:0})
      var params = {'userId' : this.userId, 'ownerKey': this.ownerKey, 'custCd': this.strCustCd, 'fromDt': this.occurrenceFromMain.replace(/-/g, ''), "toDt":this.occurrenceToMain.replace(/-/g, '')}
      this.$store.dispatch('apiOrdMstInfo', params).then(() => {
        if(this.ordMstObj.code === 'OK') {
          //console.log(this.ordMstObj)
          this.orderMstList = this.searchCondition( this.ordMstObj.ordInfo)
          mstDataProvider.setRows(this.orderMstList)
        } else {
          this.orderMstList = []
          this.$swal({
            title: this.ordMstObj.message
          })
          // alert(this.ordMstObj.message)
        }
      }).catch((error) => {
        this.$swal({
          title: 'ErrorCode = ' + error.message + '\n시스템에 이상이 있습니다. 다시 검색해 주세요.'
        })
        // alert('ErrorCode = ' + error.message + '\n시스템에 이상이 있습니다. 다시 검색해 주세요.')
        //alert('ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 검색해 주세요.')
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300)
      })
    },
    searchDtlOrder(obj) {
      //this.$loading.show({delay:0})
      //var params = {'userId' : this.userId, 'ownerKey': this.ownerKey, 'custCd': this.strCustCd, 'fromDt': this.occurrenceFromMain.replace(/-/g, ''), "toDt":this.occurrenceToMain.replace(/-/g, '')}
      this.$store.dispatch('apiOrdDtlInfo', obj).then(() => {
        if(this.ordDtlObj.code === 'OK') {
          this.orderDtlList = this.ordDtlObj.ordDtlInfo
          // console.log('orderDtlList=====')
          // console.log(this.orderDtlList)
          for(var i=0; i<this.orderDtlList.length; i++){
            Object.assign(this.orderDtlList[i], obj)
          }

          // console.log('============= console.log(this.orderDtlList)')
          // console.log(this.orderDtlList)

          dtlDataProvider.setRows(this.orderDtlList)
        } else {
          this.$swal({
            title: this.ordDtlObj.message
          })
          // alert(this.ordDtlObj.message)
        }
      }).catch((error) => {
        // alert('ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 검색해 주세요.')
        this.$swal({
          title: 'ErrorCode = ' + error.message + '\n시스템에 이상이 있습니다. 다시 검색해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300)
      })
    },
    searchCondition(array){
      this.locationVal.value
      this.processingVal.value
      this.deliveryVal.value

      var searchList = []

      for(var i=0; i<array.length; i++){
        var flag = true
        // status 값 넣기
        if(array[i].confirmYn === 'Y'){
            //확정
            array[i].status = '출고완료'
        }else{
          if(array[i].recYn === 'Y'){
            // 접수
            array[i].status = '주문확인'
          }else{
            // 미처리
            array[i].status = '주문접수'
          }
        }

       /*if(array[i].ordCd.indexOf(this.locationVal.value) === -1){
          flag = false
          continue
        }*/
        

        if(array[i].divCd.indexOf(this.deliveryVal.value) === -1){
          flag = false
          continue
        }

        if(this.processingVal.value === 3){
          //확정
          if(array[i].confirmYn === 'N'){
            // 확정 상태가 N일 경우 확정이 아니므로 continue
            flag = false
            continue
          }
        }else if(this.processingVal.value === 2){
          //접수
          if(array[i].recYn === 'N' || array[i].confirmYn === 'Y'){
            // 접수 상태가 N이거나 확정 상태가 Y일 경우 접수 상태가 아니므로 continue
            flag = false
            continue
          }
        }else if(this.processingVal.value === 1){
          //미처리
          if(array[i].recYn === 'Y'){
            // 접수 상태가 Y이면 미처리 상태가 아니므로 continue
            flag = false
            continue
          }
        }

        if(flag){
          searchList.push(array[i])
        }
      }
      return searchList
    },
    exportExcel(){    
      dtlGridView.exportGrid({
          type: "excel",
          target: "local",
          fileName: "OrderInfo.xlsx",
          showProgress: true,
          progressMessage: "엑셀 Export중입니다.",
          indicator: 'hidden',
          header: true,
          compatibility: '2010',
          linear: true,
          separateRows: true,
          allColumns:true,
          hideColumns: ["itemSeq", "ordNo", "avaYn", "avaQty"],
          lookupDisplay:true
      })
    },
    printStockList() {
      let rows = mstGridView.getCheckedRows()

      if (rows.length == 0) {
        this.$swal({
            title: '출력물을 선택해 주세요.'
        })
        return true
      }

      let ordArray = []
      var fileNames = []
      var argsArray = []
      
      for (var i in rows) {
        var data = mstDataProvider.getJsonRow(rows[i])
        // console.log(data)
        if (ordArray.indexOf(data.ordNo) == -1) {
          ordArray.push(data.ordNo)
          let tmp = {
            'ordNo': data.ordNo,
            'ownerKey': this.ownerKey,
            'userNm': this.userName
          }
          argsArray.push(tmp)
          fileNames.push('CIMS_OMS_OrderSheet')
        }
      }
      
      
      // console.log(fileNames)
      // console.log(argsArray)

      this.printDialog = true
      var paramData = this.$getOzViewData(fileNames, argsArray)
      // console.log(paramData)
      setTimeout(() => {
        this.$refs.ozViewerRef.initOzExecution(paramData)
      }, 500)
    }
  },
  mounted() {
    //console.log('------------ 기초정보 --------')
    //console.log(this.codeInfoObj)
    //console.log(this.custInfoObj)
    //console.log(this.ordCustCodeObj)

    window.JSZip = window.JSZip || JSZip

    this.locationVal = this.locationOption[0]
    this.processingVal = this.processingOption[0]
    this.deliveryVal = this.deliveryOption[0]

    mstDataProvider = new LocalDataProvider(true)
    mstGridView = new GridView('master-grid')
    mstGridView.setDataSource(mstDataProvider)
    mstGridView.setCheckBar({
      visible: true
    })
    mstGridView.setStateBar({
      visible: false
    })
    mstGridView.setPasteOptions({
      enabled: false
    })
    mstGridView.setEditOptions({
      editable: false,
      updatable: false
    })
    mstGridView.setFooters({
      visible: false
    })
    mstDataProvider.setFields(ordMstFields)
    mstGridView.setColumns(ordMstColumns)
    //mstGridView.setCheckableExpression("(values['print_yn'] = 'Y') AND (values['status'] = 'Y')", true);
    
    //mstGridView.setColumnProperty("cust_nm", "autoFilter", true)
    mstGridView.displayOptions.selectionStyle = "singleRow"
    mstGridView.displayOptions.fitStyle = "even"
    
    var tmpThis = this

    mstGridView.onCellClicked = function (grid, clickData) {
      //console.log('clickData = ' + JSON.stringify(clickData))
      //console.log(grid)
      if(clickData.cellType !== 'header' && clickData.cellType !== 'head'){
        var idx = clickData.dataRow
        var obj = mstDataProvider.getJsonRow(idx)
        //console.log('click ----')
        //console.log(obj)
        tmpThis.searchDtlOrder(obj)
      }
    }

    // 더블클릭시
    mstGridView.onCellDblClicked = function (grid, clickData) {
      //console.log('clickData = ' + JSON.stringify(clickData))
      //console.log(grid)
      if(clickData.cellType !== 'header' && clickData.cellType !== 'head'){
        var idx = clickData.dataRow
        var obj = mstDataProvider.getJsonRow(idx)
        //console.log('double click ----')
        //console.log(obj)
        if (obj.recYn === 'N') {
          sessionStorage.setItem('ordInfo', JSON.stringify(obj))
          tmpThis.$tabs.close('/OrderRegister')
          router.replace('/OrderRegister')  
        }
      }
    }

    dtlDataProvider = new LocalDataProvider(true)
    dtlGridView = new GridView('detail-grid')
    dtlGridView.setDataSource(dtlDataProvider)
    dtlGridView.setCheckBar({
      visible: false
    })
    dtlGridView.setStateBar({
      visible: false
    })
    dtlGridView.setPasteOptions({
      enabled: false
    })
    dtlGridView.setEditOptions({
      editable: false,
      updatable: false
    })
    dtlDataProvider.setFields(ordDtlFields)
    dtlGridView.setColumns(ordDtlColumns)

    dtlGridView.displayOptions.fitStyle = "even"

    dtlGridView.columnByName('avaYn').displayCallback = function (grid, index) {
      let avaQty = grid.getValue(index.dataRow,'avaQty')
      
      if(avaQty > 0){
        return 'Y'
      }else{
        return 'N'
      } 
    }
    


  },
  computed: {
    ...mapGetters({
      codeInfoObj: 'getCodeData',
      custInfoObj: 'getCustMstData',
      ordCustCodeObj: 'getOrdCodeData',
      ordMstObj: 'getOrdMstInfo',
      ordDtlObj: 'getOrdDtlInfo'
    })
  },
}
</script>